import { createAsyncThunk } from '@reduxjs/toolkit';
import { FreezePanesSettings } from '../models/freeze-panes-settings.model';

export interface SaveFreezePanesSettingsArguments {
    projectId: number;
    dataTableId: number;
    dataTableViewId: number;
    settings: FreezePanesSettings;
}

export const saveFreezePanesSettings = createAsyncThunk(
    'dataRequest/saveFreezePanesSettings',
    async (args: SaveFreezePanesSettingsArguments, thunkAPI: any) => {
        const axios = thunkAPI.getState().core.axios;
        await axios.put(
            `/api/dataRequestProjects/${args.projectId}/dataTables/${args.dataTableId}/FreezePanesSettings/dataTableView/${args.dataTableViewId}`,
            args.settings
        );
    }
);
